import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthenicationService } from '../../_services/authenication.service';
import { MessagesService } from '../../_services/messages.service';
import {environment} from '../../../environments/environment';
import { ToasterService } from '../../_services/toaster.service';
import {Ng2ImgMaxService} from "ng2-img-max";
import {ExcelServicesService} from "../../_services/excel-services.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

declare var $: any;

@Component({
  selector: 'app-letter-users',
  templateUrl: './letter-users.component.html',
  styleUrls: ['./letter-users.component.css']
})
export class LetterUsersComponent implements OnInit {

  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  returnUrl: string;
  contactlist: any;
  patients_data: any[] = [];

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private messagesService: MessagesService, private toaster: ToasterService,private excelService:ExcelServicesService,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getLetterUserList();
  }
  exportAsXLSX():void {
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(this.patients_data, 'customers_letter_users');
    this.spinnerService.hide();
  }
  getLetterUserList() {
    this.messagesService.getLetterUserList()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.contactlist = data.usersList;
            console.log(data);

            this.contactlist.forEach((row: any) => {
              const userdata = {
                Name: (row['letteruserid']['users_name'])?row['letteruserid']['users_name']:'',
                Email: (row['letteruserid']['users_email'])?row['letteruserid']['users_email']:'',
                Avatar_Name: (row['letteruserid']['users_avatar_name'])?row['letteruserid']['users_avatar_name']:'',
                interests: (row['interests'])?row['interests'].toString():'',
              };
              this.patients_data.push(userdata);
            });

            setTimeout(() => {
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('Doctor', data.ResponseMessage);
            setTimeout( () => {
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Doctor', error.error.ResponseMessage);
          setTimeout( () => {
            $(function() {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

}
